let deleteBtns = document.querySelectorAll('.delete-user')

if(deleteBtns.length) {
    for(let btn of deleteBtns) {
        btn.addEventListener('click', () => {
            let id = btn.dataset.id
    
            add_notif({
                title: 'Удаление пользователя',
                text: 'Вы уверены что хотите удалить пользователя?',
                color: 'red',
                icon: 'warning',
                btns: [
                    {
                        text: 'Удалить',
                        type: 'text',
                        color: 'red',
                        onClick: (elem) => {
                            closeNotif(elem)
                            requestAxios('deleteSelectedUser', {id}, () => {
                                window.location.reload()
                            })
                        }
                    },
                    {
                        text: 'Отмена',
                        type: 'text',
                        style: 'outline',
                        onClick: (elem) => {
                            closeNotif(elem)
                        }
                    }
                ]
            })
        })
    }
}

let enableUsers = document.querySelectorAll('.enable-user')

if(enableUsers.length) {
    for(let toggler of enableUsers) {
        toggler.addEventListener('change', () => {
            let {id} = toggler.dataset
            let disabled = toggler.checked ? 0 : 1

            requestAxios('disableUser', {id, disabled}, () => {})
        })
    }
}

let userHours = document.querySelectorAll('.user-hours')

if(userHours.length) {
    for(let input of userHours) {
        input.addEventListener('change', () => {
            let {id} = input.dataset
            let hours = Math.ceil(Number(input.value) || 0)

            requestAxios('userHours', {id, hours}, () => {})
        })
    }
}